import { useEffect } from 'react';
import { useUIStore } from '@ContractBuilder/store/ui.store';

import { useSearchHighlightNav } from '../hooks/useSearchHighlightNav';
import { SearchHighlightNav } from '../views/SearchHighlightNav';

export const SearchHighlightController = () => {
  const { activeIndex, matchCount, isVisible, goToNext, goToPrevious, dismiss } = useSearchHighlightNav();
  const setShowHiddenFields = useUIStore((state) => state.setShowHiddenFields);

  useEffect(() => {
    if (isVisible) {
      setShowHiddenFields(true);
    }
  }, [isVisible, setShowHiddenFields]);

  if (!isVisible) {
    return null;
  }

  return (
    <SearchHighlightNav
      activeIndex={activeIndex}
      matchCount={matchCount}
      onDismiss={dismiss}
      onNext={goToNext}
      onPrevious={goToPrevious}
    />
  );
};
